import React from 'react';

function Count() {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='8' fill='#E6FFFB' />
      <path
        d='M18.2001 21.7751H9.40043C8.18543 21.7751 7.20047 20.7901 7.20043 19.5751L7.2002 11.3253C7.20016 10.1103 8.18514 9.12524 9.40019 9.12524H22.5997C23.8147 9.12524 24.7997 10.1096 24.7997 11.3247L24.7998 15.1752M7.74977 12.9751H24.2498M22.0507 22.8749H23.4476M23.4476 22.8749H24.7476M23.4476 22.8749V17.7749L21.8476 18.8749'
        stroke='#13C2C2'
        stroke-width='1.8'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default Count;
